<template>
    <div>
      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item
          v-for="(item, index) in pageMeta.breadcrumb"
          :key="index"
        >
          <router-link :to="{ name: item.name }">{{ item.title }}</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ pageMeta.title }}</el-breadcrumb-item>
      </el-breadcrumb>
      <h1 class="view-head">{{ pageMeta.title }}</h1>
      <div class="view-content">
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <ul>
              <li>
                <span>插件编码</span><span>{{titleDetails.plugin_code}}</span>
              </li>
              <li>
                <span>经销商编码</span><span>{{titleDetails.client_code}}</span>
              </li>
              <li>
                <span>经销商名称</span><span>{{titleDetails.client_name}}</span>
                <el-tag 
                    v-if="$route.query.is_new == '1'"
                    class="new-tag"
                    size="small"
                  >新</el-tag>
              </li>
            </ul>
          </div>
          <div style="padding: 15px 0;">
            <span class="demonstration">监控时间筛选:</span>
            <el-date-picker
              v-model="time"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <span class="demonstration" style="margin-left: 15px;">安装类型:</span>
            <el-select v-model="is_new" placeholder="请选择">
              <el-option label="全部" value=""></el-option>
              <el-option label="新插件" value="1"></el-option>
              <el-option label="老插件" value="0"></el-option>
            </el-select>
            <el-button style="margin-left: 15px;" type="primary" @click="onSearch">查找</el-button>
          </div>
          <div class="card-content">
            <div class="table-tool" style="margin-top: 30px;">共{{totalCount}}条</div>
            <el-table
              :data="tableData"
              style="width: 100%">
              <el-table-column
                prop="time"
                label="监控时间">
              </el-table-column>
              <el-table-column
                prop="is_new"
                label="安装类型"
                :formatter="formatInstallType">
              </el-table-column>
              <el-table-column
                prop="log_content"
                label="日志内容">
              </el-table-column>
            </el-table>
          </div>
          <div class="block" v-if="totalPage>1">
            <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-size="20"
              layout="prev, pager, next, jumper"
              :total="totalCount">
            </el-pagination>
          </div>
        </el-card>
      </div>
    </div>
</template>

<script>
  import {viewLog} from '@/api/index';
    export default {
      name: "viewLog",
      beforeCreate() {
        this.pageMeta = this.$route.meta;
        this.agency_data = this.$route.params;
      },
      created() {
        this._getList(1);
      },
      data: () => ({
        currentPage: 1,
        titleDetails: {},
        searchText: '',
        totalCount: 0,
        totalPage: 0,
        time: [],
        is_new: '',
        tableData: []
      }),
      methods:{
        _getList(page){
          let start_time = '';
          let end_time = '';
          if(this.time != null){
            start_time = this.time[0]
            end_time = this.time[1]
          }
          let parameters = {
            client_code: this.agency_data.client_code,
            client_name: this.agency_data.client_name,
            plugin_code: this.agency_data.plugin_code,
            start_time: start_time,
            end_time: end_time,
            is_new: this.is_new,
            page:page
          }
          viewLog(parameters).then(res => {
            if (0 === res.status) {
              this.tableData = res.data.clientPage.list;
              this.titleDetails = res.data.clientPage;
              this.currentPage = res.data.currentPage;
              this.totalCount = res.data.totalCount;
              this.totalPage = res.data.totalPage;
            } else {
              this.tableData = [];
              this.currentPage = 1;
              this.totalCount = 0;
              this.totalPage = 0;
            }
          })
        },
        handleCurrentChange(val) {
          this._getList(val);
        },
        onSearch(){
          this._getList(1);
        },
        formatInstallType(row, column, cellValue) {
          if (cellValue === 1) {
            return '新插件';
          } else if (cellValue === 0) {
            return '老插件';
          }
          return '';
        }
      }
    }
</script>

<style scoped lang="scss">
 .clearfix ul li{
   display: inline-block;margin-right: 50px;
   span:first-child{
     margin-right: 15px;}
 }
  .demonstration{margin-right: 10px;}
.new-tag {
  flex-shrink: 0;
  color: white;
  background-color: #409EFF;
  position: relative;
  top: -2px;
  left: 5px;
}
</style>